export enum GameConceptLanguages {
  english = "english",
  spanish = "spanish",
  french = "french",
  german = "german",
  italian = "italian",
  russian = "russian",
  japanese = "japanese",
  korean = "korean",
  polish = "polish",
  chineseTraditional = "chineseTraditional",
  chineseSimplified = "chineseSimplified",
  portugueseBrazilian = "portugueseBrazilian",
  otherLanguages = "otherLanguages",
}
